export default __webpack_public_path__ + "static/media/prevention.03cd351d.svg";